import { $ } from '../bootstrap';

document.addEventListener('DOMContentLoaded', function () {
    const $roots = $('.language-select');
    if (!$roots.length) return;

    $roots.each(function () {
        const $root = $(this);
        const disabled = $root.hasClass('is-disabled');
        const bpAttr = $root.data('mobile-breakpoint');
        const breakpoint = Number.isFinite(+bpAttr) ? +bpAttr : 1024;
        const mq = window.matchMedia(`(max-width: ${breakpoint}px)`);

        const $trigger = $root.find('.language-trigger');
        const $modal = $('#languageModal');
        const $dialog = $modal.find('.modal-dialog');

        const $close = $modal.find('[data-bs-dismiss="modal"], [data-dismiss="modal"], .btn-close, .close');

        let isOpen = false;
        let $backdrop = null;
        let lastFocused = null;

        const getFocusable = ($scope) => {
            const sel = [
                'a[href]',
                'button:not([disabled])',
                'input:not([disabled])',
                'select:not([disabled])',
                'textarea:not([disabled])',
                '[tabindex]:not([tabindex="-1"])'
            ].join(',');
            return $scope.find(sel).filter(':visible');
        };

        const makeBackdrop = () => {
            if ($backdrop) return;
            $backdrop = $('<div class="modal-backdrop show"></div>');
            $('body').append($backdrop).addClass('modal-open').css('overflow', 'hidden');
        };

        const removeBackdrop = () => {
            if ($backdrop) {
                $backdrop.remove();
                $backdrop = null;
            }
            $('body').removeClass('modal-open').css('overflow', '');
        };

        const trapFocus = (e) => {
            if (!isOpen) return;
            const $focusables = getFocusable($modal);
            if (!$focusables.length) return;

            const first = $focusables[0];
            const last = $focusables[$focusables.length - 1];

            if (e.key === 'Tab') {
                if (e.shiftKey && document.activeElement === first) {
                    e.preventDefault(); last.focus();
                } else if (!e.shiftKey && document.activeElement === last) {
                    e.preventDefault(); first.focus();
                }
            } else if (e.key === 'Escape') {
                e.preventDefault(); hideModal();
            }
        };

        const showModal = () => {
            if (disabled || isOpen) return;
            isOpen = true;
            lastFocused = document.activeElement;

            $trigger.attr('aria-expanded', 'true');
            $modal.attr('aria-hidden', 'false').addClass('show').css('display', 'block');

            makeBackdrop();

            const $focusables = getFocusable($modal);
            if ($focusables.length) {
                $focusables[0].focus();
            } else if ($dialog.length) {
                $dialog.attr('tabindex', '-1').focus();
            }

            document.addEventListener('keydown', trapFocus);
        };

        const hideModal = () => {
            if (!isOpen) return;
            isOpen = false;

            $trigger.attr('aria-expanded', 'false');
            $modal.attr('aria-hidden', 'true').removeClass('show').css('display', 'none');

            removeBackdrop();
            document.removeEventListener('keydown', trapFocus);

            if (lastFocused && typeof lastFocused.focus === 'function') {
                lastFocused.focus();
            }
            lastFocused = null;
        };

        $root.on('click', function (e) {
            if (!mq.matches || disabled) return;

            if (e.target.closest('.modal')) return;

            if (e.target.closest('.language-dropdown a')) return;

            e.preventDefault();
            showModal();
        });

        $root.on('keydown', function (e) {
            if (!mq.matches || disabled) return;
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                showModal();
            }
        });
        $trigger.on('keydown', function (e) {
            if (!mq.matches || disabled) return;
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                showModal();
            }
        });

        $close.on('click', function (e) {
            e.preventDefault();
            hideModal();
        });

        $modal.on('click', function (e) {
            if (!isOpen) return;
            const insideDialog = !!e.target.closest('.modal-dialog');
            if (!insideDialog) hideModal();
        });

        $modal.on('click', '.language-item', function () {
            hideModal();
        });

        mq.addEventListener('change', function (ev) {
            if (!ev.matches) hideModal();
        });

        const observer = new MutationObserver(() => {
            const actuallyShown = $modal.hasClass('show') || $modal.css('display') === 'block';
            if (actuallyShown && !isOpen) isOpen = true;
            if (!actuallyShown && isOpen) {
                isOpen = false;
                removeBackdrop();
                document.removeEventListener('keydown', trapFocus);
                $trigger.attr('aria-expanded', 'false');
            }
        });
        observer.observe($modal[0], { attributes: true, attributeFilter: ['class', 'style', 'aria-hidden'] });
    });
});
